import React from "react";

export default class DpcLinkEsplora extends React.Component {

    getColore = (value, alpha) => {
        
        if (value){
            switch(value){
                case "0": 
                    return `rgba(255, 255, 255, ${alpha ? alpha / 100 : null})`;
                case "1": 
                    return `rgba(71, 80, 71, ${alpha ? alpha / 100 : null})`;
                case "2": 
                    return `rgba(191, 87, 89, ${alpha ? alpha / 100 : null})`;
                case "3": 
                    return `rgba(250, 220, 10, ${alpha ? alpha / 100 : null})`;
                case "4":
                    return `rgba(143, 195, 210, ${alpha ? alpha / 100 : null})`;
                default:
                    return `rgba(250, 220, 10, ${alpha ? alpha / 100 : null})`;
            }
        }
            
    }

    getColoreTesto = (value) => {
        if (value){
            switch(value){
                case "0": 
                    return `rgb(255, 255, 255)`;
                case "1": 
                    return `rgb(71, 80, 71)`;
                default:
                    return `rgb(71, 80, 71)`;
            }
        }
    }
    render() {
        if (Array.isArray(this.props.linkEsplora) && this.props.linkEsplora.length > 0)
            return (
                <section className="container btn-block-uppercase-wrapper rischi-btn-hp">
                <h3>{this.props.titoloSezione}</h3>
                <div className={`${this.props.isHomepage ? "px-custom" : ""}`}>
                <div className="row"> 
                {this.props.linkEsplora.map(
                        button => button &&
                        <>                                                         
                            <div className="col">
                            <a href={button.slug} className="btn btn-rischi"
                                style={{"--btn-color": `${this.getColore(button.coloreSfondo, button.alpha)}`, "--btn-image" : `url(${button.sfondo})`}}>                       
                                <span style={{"color": `${this.getColoreTesto(button.coloreTesto)}`}}>{button.title}</span></a>
                            </div>                                                       
                        </>
                    )
                    }
                    </div>
                </div>
                </section>
            );
        return ("");
    }
}
